module.exports = __webpack_public_path__ + "static/img/IMG_20160306_211242-EFFECTS.fef81625.jpg";